const routes = {
  labelTrackingInfo: '/labels/:id',
  fulfillments: '/fulfillments/:id',
  tracking: '/tracking/:orderId',
}

export default routes
